module.exports = __webpack_public_path__ + "static/media/16-zap.6d2d1e0f.svg";